export default jQuery;